export const FETCH_STUDENT_PROGRESS_DATA = 'FETCH_STUDENT_PROGRESS_DATA';
